import { InputNumber, Select } from 'antd'
import { currencies } from '../constants'

const { Option } = Select

type CostInputProps = {
  onCostChange: (cost: number) => void
  onCurrencyChange: (currency: string) => void
  currency?: string
  cost?: number
}

export function CostInput({ onCostChange, onCurrencyChange, currency, cost }: CostInputProps) {
  return (
    <InputNumber
      className='h-10 w-full'
      onChange={onCostChange}
      style={{ borderRadius: '4px' }}
      min={0}
      value={cost}
      addonAfter={
        <Select value={currency} defaultValue = {'SR'} className='h-10' onChange={onCurrencyChange} style={{ width: 60 }}>
          {Object.keys(currencies).map((key) => {
            const { value: currencyValue, logo } = currencies[key]
            return (
              <Option key={currencyValue} value={currencyValue}>
                {logo}
              </Option>
            )
          })}
        </Select>
      }
    />
  )
}
